// Typelizer digest e88737f2bf7a132d3841aa76d9fc8523
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** POST /mobile_pairing */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/mobile_pairing', {}, options),
    method: 'post',
  }),
}
